import React, { useEffect, useState } from 'react';
import ImageCropper from '@/components/imageCropper/imageCropper';
import { postData } from '@/services/api.service';
import { fetchCroppedImage } from '@/utils/constants';
import { ColorPicker } from 'primereact/colorpicker';
import { toast } from 'react-toastify';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import AIContentWriter from '@/components/AIContentWriter';
import AIImageGenerator from '@/components/AIImageGenerator';
import { useSelector, useDispatch } from 'react-redux';
import { setTemplateImages } from '@/core/redux/commonSlice';
import { RootState } from '@/core/redux/store';

const HomeEditBannerModalTwo = ({ theme_5, getThemeData }: any) => {
  const [editData, setEditData] = useState<any>();
  const [activeTab, setActiveTab] = useState(0);
  const [cropImageHeight, setCropImageHeight] = useState('');
  const [cropImageWidth, setCropImageWidth] = useState('');
  const [selectedCropImage, setSelectedCropImage] = useState('');
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [showCropModalTwo, setShowCropModalTwo] = useState<boolean>(false);
  const [imagedata, setImagedata] = useState<any>(null);
  const section6 = editData?.theme_5?.home?.section_6;

  const dispatch = useDispatch();
  const headerData = useSelector((state: RootState) => state.common.header);
  const templateImages = useSelector((state: RootState) => state.common.templateImages);
  const [template, setTemplate] = useState(headerData?.template);

  const [backgroundImages, setBackgroundImages] = useState<string[]>([]);
  const [iconImages, setIconImages] = useState<string[]>([]);

  useEffect(() => {
    setEditData(theme_5);
  }, [theme_5]);

  const saveJsonData = async () => {
    const payload = {
      cms_json: JSON.stringify(editData),
    };
    try {
      const response = await postData('save_cms_json', payload);
      if (response.status == 200 || response.status == 201) {
        getThemeData();
        toast.success('Theme Updated Successfully');
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  const handleChange = (e: any, index?: any) => {
    const { value, name, type, checked } = e.target;
    let updatedCollection: any = [
      ...editData.theme_5.home.section_6.card_section.collection,
    ];
    if (index != undefined) {
      updatedCollection = [
        ...editData.theme_5.home.section_6.card_section.collection,
      ];
      updatedCollection[index] = {
        ...updatedCollection[index],
        [name]: value,
      };
    }
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_5: {
        home: {
          ...prevJsonData.theme_5.home,
          section_6: {
            ...prevJsonData.theme_5.home.section_6,
            [name]: value,
            card_section: {
              ...prevJsonData.theme_5.home.section_6.card_section,
              ...prevJsonData.theme_5.home.section_6.card_section.collection[
                index
              ],
              collection: updatedCollection,
            },
          },
        },
      },
    }));
  };
  const handleBannerImageChange = (image: string) => {
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_5: {
        home: {
          ...prevJsonData.theme_5.home,
          section_6: {
            ...prevJsonData.theme_5.home.section_6,
            section_image: image,
            card_section: {
              collection: [
                ...editData.theme_5.home.section_6.card_section.collection,
              ],
            },
          },
        },
      },
    }));
  };
  const removeCollection = (index: any) => {
    let updatedCollection: any = [
      ...editData.theme_5.home.section_6.card_section.collection,
    ];
    updatedCollection.splice(index, 1);
    setActiveTab(activeTab - 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_5: {
        home: {
          ...prevJsonData.theme_5.home,
          section_6: {
            ...prevJsonData.theme_5.home.section_6,
            card_section: {
              collection: updatedCollection,
            },
          },
        },
      },
    }));
  };
  const handleImageChange = (image: string, index: any) => {
    const updatedCollection = [
      ...editData.theme_5.home.section_6.card_section.collection,
    ];
    updatedCollection[index] = {
      ...updatedCollection[index],
      collection_image: image,
    };

    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_5: {
        home: {
          ...prevJsonData.theme_5.home,
          section_6: {
            ...prevJsonData.theme_5.home.section_6,
            card_section: {
              collection: updatedCollection,
            },
          },
        },
      },
    }));
  };

  // const handleCroppedImage = async (image: any) => {
  //   setShowCropModal(false);
  //   setImagedata(image);
  // };

  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      handleBannerImageChange(imageLink);
    }
  };

  const handleCroppedImageTwo = async (image: any) => {
    setShowCropModalTwo(false);
    setImagedata(image);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      handleImageChange(imageLink, activeTab);
    }
  };

  // Auto-generate prompt based on section 6 context for Background Image
  const generateAutoPromptBanner = (): string => {
    const title = editData?.theme_5?.home?.section_6?.title || '';
    const subHeading = editData?.theme_5?.home?.section_6?.sub_heading || '';
    const paragraph = editData?.theme_5?.home?.section_6?.paragraph || '';
    
    let contextPrompt = 'modern professional section image for website';
    
    if (title || subHeading || paragraph) {
      const contextParts: string[] = [];
      if (paragraph) {
        const keywords = paragraph.split(' ').slice(0, 5).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    contextPrompt += ', clean modern aesthetic, professional photography, suitable for section image, square format, vibrant colors, high quality, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI background image save
  const handleAIImageSave = (imageUrl: string) => {
    handleBannerImageChange(imageUrl);
    setBackgroundImages(prevImages => [...prevImages, imageUrl]);
    
    const templateKey = template ? `template${template}` : 'template5';
    const currentTemplate = templateImages[templateKey] || {};
    const currentImages = currentTemplate.image || [];
    const updatedTemplateImages = {
      ...templateImages,
      [templateKey]: {
        ...currentTemplate,
        image: [...currentImages, { url: imageUrl }],
      },
    };
    dispatch(setTemplateImages(updatedTemplateImages));
  };

  // Auto-generate prompt based on current card context for Icon
  const generateAutoPromptIcon = (): string => {
    const currentCard = editData?.theme_5?.home?.section_6?.card_section?.collection?.[activeTab];
    const cardTitle = currentCard?.collection_title || '';
    const cardParagraph = currentCard?.collection_paragraph || '';
    const sectionTitle = editData?.theme_5?.home?.section_6?.title || '';
    
    let contextPrompt = 'modern minimalist icon design';
    
    if (cardTitle || cardParagraph || sectionTitle) {
      const contextParts: string[] = [];
      if (cardParagraph) {
        const keywords = cardParagraph.split(' ').slice(0, 3).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    contextPrompt += ', clean modern minimalist icon, professional design, suitable for card icon, vibrant colors, high quality, simple and recognizable, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI icon save
  const handleAIIconSave = (iconUrl: string) => {
    handleImageChange(iconUrl, activeTab);
    setIconImages(prevIcons => [...prevIcons, iconUrl]);
    
    const templateKey = template ? `template${template}` : 'template5';
    const currentTemplate = templateImages[templateKey] || {};
    const currentIcons = currentTemplate.icon || [];
    const updatedTemplateImages = {
      ...templateImages,
      [templateKey]: {
        ...currentTemplate,
        icon: [...currentIcons, { url: iconUrl }],
      },
    };
    dispatch(setTemplateImages(updatedTemplateImages));
  };

  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("150");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };

  const updateImageSectionTwo = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("150");
    // setSelectedCropImage(image);
    // setShowCropModalTwo(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImageTwo(res.target.result);
      };
    }
  };

  const addCollection = () => {
    let updatedCollection: any = [
      ...editData.theme_5.home.section_6.card_section.collection,
    ];

    let newCard = {
      collection_title: '',
      collection_image: '/assets/img/about-section/about-icon-01.png',
      isEnabled: true,
      collection_paragraph: '',
    };
    updatedCollection.splice(activeTab + 1, 0, newCard);
    setActiveTab(activeTab + 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_5: {
        home: {
          ...prevJsonData.theme_5.home,
          section_6: {
            ...prevJsonData.theme_5.home.section_6,
            card_section: {
              collection: updatedCollection,
            },
          },
        },
      },
    }));
  };
  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  // Load existing template images from Redux store with filtering
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      const templateKey = template ? `template${template}` : 'template5';
      const currentTemplate = templateImages[templateKey];
      const imageImgs = currentTemplate?.image || [];
      const iconImgs = currentTemplate?.icon || [];

      const loadImageDimensions = async (url: string): Promise<{ url: string; width: number; height: number } | null> => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => resolve({ url, width: img.width, height: img.height });
          img.onerror = () => resolve(null);
          img.src = url;
        });
      };

      if (Array.isArray(imageImgs) && imageImgs.length > 0) {
        const filterBackgroundImages = async () => {
          const imagePromises = imageImgs.map((img: any) => loadImageDimensions(img.url));
          const loadedImages = await Promise.all(imagePromises);
          const squareImages = loadedImages
            .filter((img) => {
              if (img === null) return false;
              const aspectRatio = img.width / img.height;
              return aspectRatio >= 0.9 && aspectRatio <= 1.1;
            })
            .map((img) => img!.url);
          setBackgroundImages(squareImages);
        };
        filterBackgroundImages();
      } else {
        setBackgroundImages([]);
      }

      if (Array.isArray(iconImgs) && iconImgs.length > 0) {
        const filterIconImages = async () => {
          const iconPromises = iconImgs.map((img: any) => loadImageDimensions(img.url));
          const loadedIcons = await Promise.all(iconPromises);
          const squareIcons = loadedIcons
            .filter((img) => {
              if (img === null) return false;
              const aspectRatio = img.width / img.height;
              return aspectRatio >= 0.9 && aspectRatio <= 1.1;
            })
            .map((img) => img!.url);
          setIconImages(squareIcons);
        };
        filterIconImages();
      } else {
        setIconImages([]);
      }
    } else {
      setBackgroundImages([]);
    }
  }, [templateImages, template]);
  return (
    <>
      {/* <Draggable> */}
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section6 Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <div className="row">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">
                      Title<small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={section6?.title}
                      onChange={(e) => {
                        if (e.target.value.length < 251) {
                          handleChange(e);
                        }
                      }}
                      maxLength={250}
                    />
                  </div>
                </div>
                <div className="col-md-auto">
                  <div className="mb-3">
                    <label className="form-label">Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h2color"
                        value={section6?.h2color}
                      />
                      <ColorPicker
                        name="h2color"
                        format="hex"
                        onChange={handleChange}
                        value={section6?.h2color}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md">
                    <div className="mb-3">
                      <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                        <label className="form-label mb-0 mr-2">Sub Heading</label>
                        <AIContentWriter
                          onContentGenerated={(content) => {
                            handleChange({ target: { name: 'sub_heading', value: content } });
                          }}
                          contentType="website_description"
                          placeholder="Describe the sub heading you want"
                          context="This is for the section 6 sub heading with 1 line or 10 words max"
                        />
                      </div>
                    <input
                      type="text"
                      className="form-control"
                      name="sub_heading"
                      value={section6?.sub_heading}
                      onChange={(e) => {
                        if (e.target.value.length < 120) {
                          handleChange(e);
                        }
                      }}
                      maxLength={250}
                    />
                  </div>
                </div>
                <div className="col-md-auto">
                  <div className="mb-3">
                    <label className="form-label">Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h3color"
                        value={section6?.h3color}
                      />
                      <ColorPicker
                        name="h3color"
                        format="hex"
                        onChange={handleChange}
                        value={section6?.h3color}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md">
                    <div className="mb-3">
                      <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                        <label className="form-label mb-0 mr-2">Paragraph</label>
                        <AIContentWriter
                          onContentGenerated={(content) => {
                            handleChange({ target: { name: 'paragraph', value: content } });
                          }}
                          contentType="website_description"
                          placeholder="Describe the paragraph content you want"
                          context="This is for the section 6 paragraph with 3 lines max"
                        />
                      </div>
                    <input
                      type="text"
                      className="form-control"
                      name="paragraph"
                      value={section6?.paragraph}
                      onChange={(e) => {
                        if (e.target.value.length < 1200) {
                          handleChange(e);
                        }
                      }}
                      maxLength={1200}
                    />
                  </div>
                </div>
                <div className="col-md-auto">
                  <div className="mb-3">
                    <label className="form-label">paragraph Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="paracolor"
                        value={section6?.paracolor}
                      />
                      <ColorPicker
                        name="paracolor"
                        format="hex"
                        onChange={handleChange}
                        value={section6?.paracolor}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">Background</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="background_image_color"
                        value={section6?.background_image_color}
                        onChange={handleChange}
                        maxLength={250}
                      />
                      <ColorPicker
                        name="background_image_color"
                        format="hex"
                        onChange={handleChange}
                        value={section6?.background_image_color}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row d-none">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">Upload Image</label>
                    <input
                      type="file"
                      accept="image/png, image/jpeg"
                      className="form-control"
                      name="image"
                      onChange={updateImageSectionOne}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* AI Image Generator */}
            <AIImageGenerator
              generateAutoPrompt={generateAutoPromptBanner}
              onSave={handleAIImageSave}
              imageType="image"
              defaultWidth="1024"
              defaultHeight="1024"
              title="AI Image"
              autoGenerate={true}
              template={template}
            />

            <div className="row">
              <div className="col-md">
                <div className="mb-3">
                  <label className="form-label">Upload Image</label>
                  <input type="file" accept="image/png, image/jpeg" className="form-control" name="image" onChange={updateImageSectionOne} />
                </div>
              </div>
            </div>

            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="img-bg active">
                          {section6?.section_image && (
                            <img
                              src={section6?.section_image}
                              alt="Hero Image"
                            />
                          )}
                        </div>
                        <div className="img-options">
                          <div className="row">
                            <div className="col-md-12">
                              {backgroundImages.length > 0 ? (
                                <Swiper
                                  spaceBetween={15}
                                  navigation={true}
                                  modules={[Navigation]}
                                  breakpoints={{
                                    640: { slidesPerView: 1 },
                                    768: { slidesPerView: 4 },
                                    1024: { slidesPerView: 6 },
                                  }}
                                  className="homejson-slider"
                                >
                                  {backgroundImages.map((imageUrl: string, idx: number) => (
                                    <SwiperSlide key={idx}>
                                      <div className="img-option" onClick={() => handleBannerImageChange(imageUrl)}>
                                        <img src={imageUrl} alt="Hero Image" className="img-fluid" />
                                      </div>
                                    </SwiperSlide>
                                  ))}
                                </Swiper>
                              ) : (
                                <div className="empty-slider-state text-center py-4">
                                  <div className="empty-state-content">
                                    <i className="fas fa-images fa-3x text-muted mb-3"></i>
                                    <h6 className="text-muted mb-2">No Background Images Available</h6>
                                    <p className="text-muted small mb-3">Generate AI images or upload your own to see them here</p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <ul className="nav nav-tabs">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="homejson-slider"
                >
                  {editData?.theme_5?.home?.section_6?.card_section?.collection.map(
                    (card: any, index: any) => (
                      <SwiperSlide key={index}>
                        <li key={index} className="nav-item nav-option">
                          <a
                            className={`nav-link ${
                              activeTab === index ? 'active' : ''
                            }`}
                            onClick={() => setActiveTab(index)}
                          >
                            Card Section {index + 1}
                          </a>
                          <a
                            className="tab-close"
                            onClick={() => {
                              removeCollection(index);
                            }}
                          >
                            <i className="fas fa-times" aria-hidden="true"></i>
                          </a>
                        </li>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </ul>
              <div className="tab-content">
                {editData?.theme_5?.home?.section_6?.card_section?.collection.map(
                  (card: any, index: any) => (
                    <div
                      key={index}
                      className={`tab-pane fade ${
                        activeTab === index ? 'show active' : ''
                      }`}
                    >
                      <div className="row">
                        <div className="col-md-12">
                          <div className="img-bg active">
                            {card.collection_image && (
                              <img
                                src={card.collection_image}
                                alt={`Card Icon ${index + 1}`}
                              />
                            )}
                          </div>
                          <div className="img-options w-100">
                            {iconImages.length > 0 ? (
                              <Swiper
                                spaceBetween={15}
                                navigation={true}
                                modules={[Navigation]}
                                breakpoints={{
                                  640: { slidesPerView: 1 },
                                  768: { slidesPerView: 4 },
                                  1024: { slidesPerView: 6 },
                                }}
                                className="homejson-slider"
                              >
                                {iconImages.map((iconUrl: string, iconIndex: number) => (
                                  <SwiperSlide key={iconIndex}>
                                    <div
                                      className="img-option"
                                      onClick={() => handleImageChange(iconUrl, index)}
                                    >
                                      <img src={iconUrl} alt="Icon" className="img-fluid" />
                                    </div>
                                  </SwiperSlide>
                                ))}
                              </Swiper>
                            ) : (
                              <div className="empty-slider-state text-center py-4">
                                <div className="empty-state-content">
                                  <i className="fas fa-icons fa-3x text-muted mb-3"></i>
                                  <h6 className="text-muted mb-2">No Icons Available</h6>
                                  <p className="text-muted small mb-3">Generate AI icons or upload your own to see them here</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* AI Image Generator */}
                      <AIImageGenerator
                        generateAutoPrompt={generateAutoPromptIcon}
                        onSave={handleAIIconSave}
                        imageType="icon"
                        defaultWidth="128"
                        defaultHeight="128"
                        title="AI Icon"
                        autoGenerate={true}
                        template={template}
                      />
                      {/* Upload Icon below AI generator */}
                      <div className="mb-3">
                        <label className="form-label">Upload Image</label>
                        <input
                          type="file"
                          accept="image/png, image/jpeg"
                          className="form-control"
                          name="image"
                          onChange={updateImageSectionTwo}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                          Title<small>(max 250 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="collection_title"
                          value={card.collection_title}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={250}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                          <label className="form-label mb-0 mr-2">Paragraph</label>
                          <AIContentWriter
                            onContentGenerated={(content) => {
                              handleChange({
                                target: { name: 'collection_paragraph', value: content },
                              }, index);
                            }}
                            contentType="website_description"
                            placeholder="Describe the paragraph content you want"
                            context="This is for a section 6 card paragraph with 1 line or 10 words max"
                          />
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          name="collection_paragraph"
                          value={card.collection_paragraph}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={1200}
                        />
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
            <div className="edit-section">
              <div className="row">
                <div
                  onClick={() => {
                    addCollection();
                  }}
                  className="col text-center"
                >
                  Add Card<i className="fas fa-plus-square ms-2"></i>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={() => {
                  saveJsonData();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* </Draggable> */}
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: 'block' }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
      {showCropModalTwo ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: 'block' }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImageTwo}
              close={() => {
                setShowCropModalTwo(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default HomeEditBannerModalTwo;
